import React from 'react';
import { connect } from 'react-redux';

import {
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  ListGroup,
  ListGroupItem
} from 'reactstrap';
import { Switch, Redirect, Route, Link, NavLink } from 'react-router-dom';
import Dynamic from '../Dynamic/Dynamic';
import ProductCta from '../../components/ProductCta/ProductCta';
import ProductCtaBar from '../../components/ProductCta/ProductCtaBar';

import pageComponents from './likwidacja/';

// Same destination as the "Zgłoś szkodę" button on the dashboard tile
const CLAIM_URL = 'https://zglosicszkode.pl/';

const pracownicyData = [
  { title: 'Likwidacja', component: 'Ogolne', link: 'opis/' }
];

class PublicTwoColumnTemplate extends React.Component {
  render() {
    let currentBreadcrumb;

    const menu = pracownicyData.map((item) => {
      if (item.externalLink) {
        return (
          <ListGroupItem
            tag="a"
            key={item.title}
            href={item.externalLink}
            target="_blank"
            rel="noopener noreferrer"
            action>
            {item.title}
          </ListGroupItem>
        );
      }

      if (
        !currentBreadcrumb &&
        (`${this.props.match.path}${item.link}` ===
          this.props.location.pathname ||
          `${this.props.match.path}${item.link}` ===
            `${this.props.location.pathname}/`)
      ) {
        currentBreadcrumb = (
          <BreadcrumbItem active>{item.title}</BreadcrumbItem>
        );
      }

      // Temporary
      if (this.props.location.pathname === '/pracownicy/kup/') {
        currentBreadcrumb = <BreadcrumbItem active>Wycena</BreadcrumbItem>;
      }

      const link = `${this.props.match.path}${item.link}`;
      return (
        <ListGroupItem tag={NavLink} key={item.title} to={link} action>
          {item.title}
        </ListGroupItem>
      );
    });

    const routes = pracownicyData.map((item) => {
      if (item.component) {
        return (
          <Route
            key={item.link}
            path={`${this.props.match.path}${item.link}`}
            component={pageComponents[item.component]}
          />
        );
      }
      return null;
    });

    // A menu with the current page as its only entry leads nowhere - skip it
    const hasMenu = pracownicyData.length > 1;

    return (
      <div>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/">{this.props.rootSection}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to={this.props.match.path}>{this.props.section}</Link>
          </BreadcrumbItem>
          {currentBreadcrumb}
        </Breadcrumb>

        <Row>
          <Col xs="12" sm="3">
            <div className="productSidebarSticky">
              {hasMenu && <ListGroup>{menu}</ListGroup>}
              <ProductCta
                href={CLAIM_URL}
                className={hasMenu ? 'mt-4' : undefined}
                block>
                Zgłoś szkodę
              </ProductCta>
            </div>
          </Col>
          <Col xs="12" sm="9">
            <Switch>
              {routes}
              {this.props.isAuthenticated && (
                <Route
                  path={`/likwidacja/kup/`}
                  render={(props) => (
                    <Dynamic
                      {...props}
                      guid="1f3a17bc-a0f9-4f2b-9c92-60947514697d"
                      // key={props.match.params.guid}
                    />
                  )}
                />
              )}
              <Redirect exact from="/likwidacja" to="/likwidacja/opis/" />
              <Redirect
                from="/likwidacja/kup/"
                to={{
                  pathname: '/login',
                  state: { referrer: this.props.location.pathname }
                }}
              />
              <Redirect
                to={{
                  pathname: '/login',
                  state: { referrer: this.props.location.pathname }
                }}
              />
            </Switch>
          </Col>
        </Row>
        <ProductCtaBar title="Szkoda komunikacyjna">
          <ProductCta href={CLAIM_URL}>Zgłoś szkodę</ProductCta>
        </ProductCtaBar>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null
    // username: state.auth.user.name,
    // menu: state.menu.data ? state.menu.data.menu : []
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // logout: () => dispatch(logout())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicTwoColumnTemplate);
